module.exports = __webpack_public_path__ + "static/media/ForestBanner.23788b20.svg";